module.exports = __webpack_public_path__ + "media/home_hero-1200.273367da.webm";